import Account from './Account'

export default Account



// WEBPACK FOOTER //
// ./src/views/Account/index.js